<nav class="layout-breadcrumb">
    <ol>
        <ng-template ngFor let-item let-last="last" [ngForOf]="breadcrumbs$ | async">
            <a [routerLink]="item.url">{{item.label}}</a>
            <li *ngIf="!last" class="layout-breadcrumb-chevron"> <i class="pi pi-chevron-right"></i> </li>
        </ng-template>
    </ol>
</nav>